export default __webpack_public_path__ + "static/media/tss_logo.a9badabb.png";